import api from "../../services/forecastService";
import axios from "axios";
import forecast_api from "../../services/forecastService";
import moment from 'moment';
import {EventBus} from "../../eventBus";
import router from '@/router';

const state = {
    table_loading: false,
    allow_approve: false,
    selected_forecast_date: null,
    selected_forecast_start_date: null,
    selected_forecast_end_date: null,
    selected_forecast_view: 'sales',
    selected_view: 'week',
    selected_outlet: null,
    failed_page: false,
    show_by_view: false,
    customDateFormat: null,
    outlets: [],
    payload: {
        outlet: null,
        start_date: null,
        end_date: null,
        view: null,
        no_of_weeks: null,
    },
    weather_data: [],
    event_data: [],
    planing_data: [],
    forecast_popup_loading: false,
    selected_store_level: null,
    set_selected_approve_date: null,
    approve_dates_list: [],
    selected_store_id: null,
    event_categories: [],
    forecast_popup_loaded: false,
    forecast_approve_data: null,
    forecast_approve_data_clone: null,
    graph_label: null,
    forecast_graph_data: null,
    old_amount: null,
    forecast_graph_data_sales: null,
    store_forecast_data:[],
    is_forecast_approved: false,
    forecast_day_level_data: [],
    summary_data: [],
    approve_forecast_loading: false,
    forecast_last_update_date: null,
    selected_order_type: 'all',
    efficiency_data: null
}

const mutations = {
    SET_SELECTED_FORECAST_DATE(state, payload) {
        state.selected_forecast_date = payload;
    },
    SET_SELECTED_FORECAST_START_DATE(state, payload) {
        state.selected_forecast_start_date = payload;
    },
    SET_SELECTED_FORECAST_END_DATE(state, payload) {
        state.selected_forecast_end_date = payload;
    },
    SET_SELECTED_FORECAST_VIEW(state, payload) {
        state.selected_forecast_view = payload;
    },
    SET_SELECTED_VIEW(state, payload) {
        state.selected_view = payload;
    },
    HANDLE_APPROVE_ACTION(state, condition) {
        state.allow_approve = condition;
    },
    SET_SELECTED_OUTLET(state, payload) {
        state.selected_outlet = payload;
    },
    SET_FAILED_PAGE(state, payload) {
        state.failed_page = payload;
    },
    SET_SHOW_BY_VIEW(state, payload) {
        state.show_by_view = payload;
    },
    SET_OUTLETS(state, payload) {
        state.outlets = payload;
    },
    SET_PAYLOAD(state, payload) {
        state.payload = payload;
    },
    SET_TABLE_DATA(state, payload) {
        state.tableData = payload;
    },
    SET_GRAPH_DATA(state, payload) {
        state.graphData = payload;
    },
    SET_CUSTOM_DATE_FORMAT(state, payload) {
        state.customDateFormat = payload;
    },
    SET_WEATHER_DATA(state, payload) {
        state.weather_data = payload;
    },
    SET_EVENT_DATA(state, payload) {
        state.event_data = payload;
    },
    SET_PLANING_DATA(state, payload) {
        state.planing_data = payload;
    },
    HANDLE_TABLE_LOADING(state, payload) {
        state.table_loading = payload;
    },
    HANDLE_FORECAST_LOADING(state, data){
        state.forecast_popup_loading = data;
    },
    SET_SELECTED_STORE_NAME(state, data){
        state.selected_store_level = data.name;
        state.selected_store_id = data.id[0];
    },
    SET_SELECTED_APPROVE_DAT(state, data){
        state.set_selected_approve_date = data;
    },
    SET_APPROVE_DATES_LIST(state, data){
        state.approve_dates_list = data;
    },
    SET_EVENT_CATEGORIES(state, data){
        state.event_categories = data;
    },
    HANDLE_FORECAST_DATA_LOAD(state, data){
        state.forecast_popup_loaded = data;
    },
    SET_FORECAST_APPROVE_DATA(state, data){
        state.forecast_approve_data = JSON.parse(JSON.stringify(data));
        state.forecast_approve_data_clone = JSON.parse(JSON.stringify(data));
        state.old_amount = state.forecast_approve_data.forecast.amount;
        let arr = [];
        const obj = {
            'sale_year': 'Last Year',
            'sale_week': 'Last Week',
            'forecast': 'Forecast',
        }
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                if(key !== 'trend'){
                    const element = data[key];
                    console.log(element, 'element');
                    arr.push(`${obj[key]} - ${moment(element.date, 'YYYY-MM-DD').format('DD MMM YY, ddd')}`);
                } else if(key === 'trend'){
                    arr.push(`Current Trend`);
                }
            }
        }
        let order = ["Last Year", "Last Week", "Current Trend", "Forecast"];
        // Sort arr based on order
        arr.sort((a, b) => order.indexOf(a.split(' - ')[0]) - order.indexOf(b.split(' - ')[0]));
        state.graph_label = arr;
    },
    SET_FORECAST_APPROVE_GRAPH_DATA(state, data){
        console.log(state.forecast_approve_data, 'state.forecast_approve_data')
        let arr = [];
        // Push trx
        arr.push(state.forecast_approve_data.sale_year.sales);
        arr.push(state.forecast_approve_data.sale_week.sales);
        arr.push(state.forecast_approve_data.trend.trend_transactions);
        arr.push(state.forecast_approve_data.forecast.adjusted_quantity);

        console.log(arr, 'arr')
        state.forecast_graph_data = arr;
        state.old_amount = state.forecast_approve_data.forecast.amount;
    },
    SET_FORECAST_APPROVE_GRAPH_DATA_SALES(state, data){
        let arr_sales = [];
        // Push sales
        arr_sales.push(state.forecast_approve_data.sale_year.amount);
        arr_sales.push(state.forecast_approve_data.sale_week.amount);
        arr_sales.push(0);
        arr_sales.push(state.forecast_approve_data.forecast.amount);
        state.forecast_graph_data = arr_sales;
    },
    SET_STORE_FORECAST_DATA(state, data){
        state.store_forecast_data = data;
    },
    HANDLE_FORECAST_STATUS(state, data){
        // console.log("this.computedTableData   *", data);
        state.is_forecast_approved = data;
    },
    SET_TABLE_DATA_For_DAY(state, data){
        state.forecast_day_level_data = data;
    },
    SET_SUMMARY_DATA(state, data){
        state.summary_data = data;
    },
    SET_APPROVE_LOADING(state, data){
        approve_forecast_loading = data;
    },
    SET_FORECAST_LAST_UPDATE_DATE(state, data){
        state.forecast_last_update_date = data;
    },
    SET_BASICS(state, data){
        state.selected_forecast_view = data;
    },
    SET_ORDER_TYPE(state, data){
        state.selected_order_type= data;
    },
    SET_EFFICIENCY_DATA(state, data){
        state.efficiency_data= data;
    }
}

const actions = {
    callWeekDayLevelApiAction({ commit, dispatch }, payload) {
        commit('HANDLE_TABLE_LOADING', true);
        payload.basics = state.selected_forecast_view;
        if(state.selected_order_type !== 'all' && state.selected_forecast_view === 'sales'){
            payload.order_type = state.selected_order_type;
        }
        const summary_payload = { view: payload.view === 'hour' ? 'day' : 'week', start_date: payload.start_date, end_date: payload.end_date, outlet: payload.outlet};
        dispatch('getSummaryDataAction', summary_payload);
        if(state.selected_forecast_view === 'sales'){
            dispatch('callEfficiencyApiAction', payload);
        }
        api.getPlaningData(payload).then(response => {
            commit('SET_PLANING_DATA', JSON.parse(response.data));
            commit('SET_STORE_FORECAST_DATA', JSON.parse(response.data));
            // Save Day level data
            if(payload.view === 'day'){
                commit('SET_TABLE_DATA_For_DAY', JSON.parse(response.data));
            }
            commit('HANDLE_TABLE_LOADING', false);
        }).catch(error => {
            console.error('Error fetching data:', error);
            commit('HANDLE_TABLE_LOADING', false);
        });
    },
    callEfficiencyApiAction({ commit, dispatch }, payload) {
        api.getPlaningEfficiency(payload).then(response => {
            commit('SET_EFFICIENCY_DATA', JSON.parse(response.data));
        }
        ).catch(error => {
            console.error('Error fetching data:', error);
        });
    },
    callHourLevelApiAction({ commit, dispatch }, payload) {
        let updated_payload = {...state.payload};
        updated_payload.basics = state.selected_forecast_view;
        if(state.selected_order_type !== 'all' && state.selected_forecast_view === 'sales'){
            updated_payload.order_type = state.selected_order_type;
        }
        commit('HANDLE_TABLE_LOADING', true);
        const summary_payload = { view: state.payload.view === 'hour' ? 'day' : 'week', start_date: state.payload.start_date, end_date: state.payload.end_date, outlet: state.payload.outlet};
        dispatch('getSummaryDataAction', summary_payload);
        const { date, store_id } = payload;
        const requestData = {
            event: {
                from_date: date, to_date: date, outlet: store_id, filters: {
                    "outlets": [],
                    "countries": [],
                    "regions": [],
                    "subregions": []
                }
            },
            weather: { from_date: date, to_date: date, outlet: store_id },
            planing: updated_payload
        };
        api.getHourlyForecastDetails(requestData)
            .then(axios.spread((events, weather, planing, efficiency) => {
                commit('HANDLE_TABLE_LOADING', false);
                if(state.selected_forecast_view === 'sales'){
                    dispatch('callEfficiencyApiAction', requestData.planing);
                }
                if (events.status === 200 && weather.status === 200) {
                    commit('SET_EVENT_DATA', JSON.parse(events.data));
                    commit('SET_WEATHER_DATA', JSON.parse(weather.data));
                    commit('SET_PLANING_DATA', JSON.parse(planing.data));
                } else {
                    console.error('Error: One of the requests failed');
                }
            }))
            .catch((error) => {
                commit('HANDLE_TABLE_LOADING', false);
                console.error('Error fetching data:', error);
            });
    },
    getEventsAction({ commit }, params) {
       let payload = {
            from_date: params.date, to_date: params.date, outlet: params.store_id, filters: {
                "outlets": [],
                "countries": [],
                "regions": [],
                "subregions": []
            }
        };
        api.getStoreEvents(payload).then(response => {
            commit('SET_EVENT_DATA', JSON.parse(response.data));
        }).catch(error => {
            console.error('Error fetching data:', error);
        });
    },
    getAllOutletsAction({ commit }) {
        api.getOutlets().then(response => {
            commit('SET_OUTLETS', JSON.parse(response.data));
        }
        ).catch(error => {
            console.error('Error fetching data:', error);
        });
    },
    loadApproveForecastData({commit,dispatch}){
        let type = 'sale';
        let obj = {
            forecast: { date: state.set_selected_approve_date, outlet: state.selected_outlet, type: "forecast", date_offset: null},
            week: { date: state.set_selected_approve_date, outlet: state.selected_outlet, type: type, date_offset: 'week'},
            year: { date: state.set_selected_approve_date, outlet: state.selected_outlet, type: type, date_offset: 'year'},
        }
        dispatch('callForecastApi', obj);
        // Call Events API
        let event_obj = {
            "from_date": state.set_selected_approve_date,
            "to_date": state.set_selected_approve_date,
            "res_type": "date_mul",
            "filters": {
                "outlets": [
                    state.selected_outlet
                ],
                "countries": [],
                "regions": [],
                "subregions": []
            }
        };
        dispatch('callEventsApi', event_obj)
	},
    getSummaryDataAction({commit}, payload){
        api.getSummaryData(payload).then((res)=>{
            let data = JSON.parse(res.data);
            commit('SET_SUMMARY_DATA', data);
        }).catch((err)=>{
            console.error(err)
        });
    },
    callEventsApi({commit}, payload){
		api.getEventCategory().then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_EVENT_CATEGORIES', data);
		}).catch((err)=>{
			console.error(err)
		});
	},
    getForecastStatus({commit}, payload){
		api.getForecastLastUpdateDate(payload).then((res)=>{
			let data = JSON.parse(res.data);
			commit('SET_FORECAST_LAST_UPDATE_DATE', data);
		}).catch((err)=>{
			console.error(err)
		});
	},
    callForecastApi({commit}, payload){
        commit('HANDLE_FORECAST_LOADING', true);
        commit('HANDLE_FORECAST_DATA_LOAD', false);
        forecast_api.allForecastQueryDetail(payload).then(axios.spread((
            forecastRes,
            weekRes,
            yearRes,
            trendRes
        )=>{
            if( forecastRes.status == 200 &&
                weekRes.status == 200 &&
                yearRes.status == 200 &&
                trendRes.status == 200
            ) {
                let forecastData = JSON.parse(forecastRes.data);
                let weekData = JSON.parse(weekRes.data);
                let yearData = JSON.parse(yearRes.data);
                let trendData = JSON.parse(trendRes.data);
                let obj = {
                    forecast: forecastData,
                    sale_week: weekData,
                    sale_year: yearData,
                    trend: trendData
                };
                commit('SET_FORECAST_APPROVE_DATA', obj);
                commit('HANDLE_FORECAST_LOADING', false);
                commit('HANDLE_FORECAST_DATA_LOAD', true);
                commit('SET_FORECAST_APPROVE_GRAPH_DATA');
            }

            // forecast_api.forecastQuery(payload.obj, payload.query_params).then((res)=>{
            //     let data = JSON.parse(res.data);
            //     let id_list = [];
            //     for (const store of data.results) { id_list.push(Object.keys(store)[0]) }
            //     let mapped_name_payload = {"basics": "product", "id_list": id_list };
            //     if(router.currentRoute.name === 'SalesCategoryForecast') {
            //         dispatch('getnameMappingDataAction', mapped_name_payload);
            //     }
            //     commit('SET_STORE_FORECAST_DATA', data);
            //     commit('HANDLE_TABLE_LOADING', false);
            // }).catch((err)=>{
            //     console.error(err);
            //     commit('HANDLE_TABLE_LOADING', false);
            // });

        })).catch((err)=>{
            console.error(err);
        }).finally(()=>{
            EventBus.$emit("renderDayForecastGraph")
        });
    },
}

const getters = {
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
};